(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__langSheetBound) return;
    window.__langSheetBound = true;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-lang-open]');
      if (opener) {
        var sheet = document.getElementById(opener.getAttribute('aria-controls'));
        if (sheet && sheet.showModal) {
          if (window.matchMedia('(min-width: 750px)').matches) {
            var rect = opener.getBoundingClientRect();
            sheet.style.top = Math.round(rect.bottom + 8) + 'px';
            sheet.style.right = Math.max(8, Math.round(window.innerWidth - rect.right)) + 'px';
            sheet.style.left = 'auto';
            sheet.style.bottom = 'auto';
          } else {
            sheet.style.top = '';
            sheet.style.right = '';
            sheet.style.left = '';
            sheet.style.bottom = '';
          }
          sheet.showModal();
          opener.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      var closer = event.target.closest('[data-lang-close]');
      if (closer) {
        closer.closest('dialog').close();
        return;
      }

      if (event.target.matches && event.target.matches('dialog.lang-sheet')) {
        event.target.close();
      }
    });

    document.addEventListener(
      'close',
      function (event) {
        if (event.target.matches && event.target.matches('dialog.lang-sheet')) {
          document.querySelectorAll('[data-lang-open]').forEach(function (button) {
            button.setAttribute('aria-expanded', 'false');
          });
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-badges"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-ship-badge')) {
    customElements.define('free-ship-badge', class extends HTMLElement {
      connectedCallback() {
        const price = parseInt(this.dataset.price || '0', 10);
        const cur = this.dataset.currency || 'USD';
        const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
        const base = rate === 1 && cur === 'USD' ? 9900 : 10000;
        this.hidden = !(price >= Math.ceil(base * rate));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
